import React from "react";

// Utility function for handling inline field errors from API responses
export const handleInlineErrors = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  err: any,
  setFieldErrors: React.Dispatch<React.SetStateAction<Record<string, string>>>
) => {
  const error = err?.response?.data?.error;
  console.error("API Error:", error);

  if (error?.inline && error?.display) {
    setFieldErrors((prev) => ({
      ...prev,
      [error.inline]: error.display,
    }));
  }
};

// Clear specific field errors when form data changes
export const clearFieldErrors = (
  updatedFields: string[],
  setFieldErrors: React.Dispatch<React.SetStateAction<Record<string, string>>>
) => {
  setFieldErrors((prev) => {
    const newErrors = { ...prev };
    updatedFields.forEach((field) => {
      delete newErrors[field];
    });
    return newErrors;
  });
};
